/* DZ Runde 36: Steuerung des Cart-Drawers.
   Vanilla, kein Framework, keine Theme-Importe - laedt mit defer beim
   Seitenaufbau, nicht beim Oeffnen des Drawers.
   Jede Warenkorb-Aenderung geht ueber die Section-Rendering-API
   (Parameter "sections"), damit Kopf, Leiste, Liste und Footer in einer
   Antwort kommen und nichts nachgerechnet werden muss. */
(function () {
  "use strict";

  var RECS = "dz-cart-recs";
  var recsHtml = null;

  function drawer() {
    return document.querySelector("cart-drawer");
  }
  function sid() {
    var d = drawer();
    return d ? d.getAttribute("data-section-id") : null;
  }
  function body() {
    return document.querySelector("[data-dz-cart]");
  }

  /* Der Warenkorb-Zaehler in der Kopfleiste zaehlt weiter alles, der im
     Drawer nur Ware ohne Prio-Versand. Beide kommen deshalb aus ihrer
     eigenen Section - frueher kopierte das Skript die Drawer-Zahl nach
     oben, das wuerde jetzt die falsche Zahl in die Kopfleiste tragen. */
  function post(url, daten) {
    daten.sections = sid() + ",cart-icon-bubble";
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(daten)
    }).then(function (r) {
      return r.json().then(function (j) {
        return { ok: r.ok, daten: j };
      });
    });
  }

  /* Ganzen Drawer-Koerper aus der Section-Antwort ersetzen. Das deckt auch
     den Wechsel voll -> leer ab, den Teil-Anker nicht abbilden koennen. */
  function neuZeichnen(sections) {
    kopfleisteNachziehen(sections);
    var html = sections && sections[sid()];
    var ziel = body();
    if (!html || !ziel) return;
    var neu = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector("[data-dz-cart]");
    if (!neu) return;
    var warOffen = !!ziel.querySelector(".dz-cd__recs-panel.offen");
    ziel.innerHTML = neu.innerHTML;
    if (warOffen && recsHtml) recsEinsetzen(recsHtml, true);
  }

  /* Kopfleiste aus ihrer eigenen Section nachziehen. */
  function kopfleisteNachziehen(sections) {
    var html = sections && sections["cart-icon-bubble"];
    if (!html) return;
    var neu = new DOMParser().parseFromString(html, "text/html").querySelector("#cart-icon-bubble");
    if (!neu) return;
    ["#cart-icon-bubble", "#cart-icon-bubble-mobile"].forEach(function (s) {
      var n = document.querySelector(s);
      if (n) n.innerHTML = neu.innerHTML;
    });
  }

  /* R77: es scrollt der gemeinsame Bereich (Empfehlungen + Positionen),
     nicht mehr die Liste allein. */
  function ansEnde() {
    var liste = document.querySelector(".dz-cd__scroll") || document.querySelector(".dz-cd__liste");
    if (!liste) return;
    requestAnimationFrame(function () {
      liste.scrollTop = liste.scrollHeight;
    });
  }

  function sperren(el, an) {
    if (!el) return;
    if (an) el.setAttribute("aria-busy", "true");
    else el.removeAttribute("aria-busy");
  }

  /* --- Menge und Entfernen -------------------------------------------
     Runde 43 sammelte Klicks je Zeile und schickte /cart/change mit dem
     Zeilen-Key. Das reichte nicht (R84, gemessen 15.10. auf V32):
     Shopify verteilt bei jeder Mengenaenderung die Rabatte neu, teilt
     dabei eine Variante in zwei Zeilen (z. B. 7 + 4) und vergibt neue
     Keys - auch fuer ANDERE Zeilen, deren Rabatt sich verschiebt. Ein
     Nachzuegler mit dem alten Key lief in 400 und ging verloren, und
     ein Neuzeichnen mitten im Klicken setzte die Anzeige zurueck.

     Jetzt: eine Warteschlange fuer den ganzen Warenkorb (dzMenge).
     - Ein Klick zaehlt nur die Anzeige der Zeile hoch und merkt sie vor.
     - Nach 350 ms Ruhe geht EINE Anfrage raus: /cart/update.js mit den
       Keys aus der LETZTEN Serverantwort. Ziel je Gruppe (Variante +
       Eigenschaften + Abo-Plan) ist die Summe aller ihrer Zeilen in der
       Anzeige - so stimmt die Menge auch, wenn Shopify die Zeilen
       zwischendurch neu aufteilt.
     - Nie zwei Anfragen gleichzeitig. Wird waehrend einer Anfrage
       weitergeklickt, bleibt die Anzeige stehen und die naechste
       Anfrage folgt; gezeichnet wird erst die letzte Antwort.
     - Fehler: Warenkorb frisch vom Server zeichnen und kurz melden.
     Die Seite /cart (module-add-to-cart.js) nutzt dieselbe Schlange. */
  var MENGE_RUHE = 350;
  var gruppeVon = {};
  var mengeVon = {};
  var stand = null;
  var vorgemerkt = [];
  var mengeTimer = null;
  var laeuft = false;

  function gruppe(i) {
    return i.variant_id + "|" + JSON.stringify(i.properties || {}) + "|" + (i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : "");
  }

  function standMerken(c) {
    if (!c || !c.items) return;
    stand = c;
    c.items.forEach(function (i) {
      gruppeVon[i.key] = gruppe(i);
      mengeVon[i.key] = i.quantity;
    });
  }

  function standHolen(frisch) {
    if (stand && !frisch) return Promise.resolve(stand);
    return fetch("/cart.js", { cache: "no-store" })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        standMerken(c);
        return c;
      });
  }

  function melden(text) {
    var m = document.querySelector("[data-dz-menge-meldung]");
    if (!m) {
      m = document.createElement("div");
      m.setAttribute("data-dz-menge-meldung", "");
      m.setAttribute("role", "status");
      /* fixiert, damit die Meldung nichts verschiebt */
      m.style.cssText = "position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;max-width:min(92vw,420px);padding:10px 16px;border-radius:10px;background:#1d1d1f;color:#fff;font-size:14px;line-height:1.35;text-align:center;box-shadow:0 4px 16px rgba(0,0,0,.2)";
      document.body.appendChild(m);
    }
    m.textContent = text;
    m.hidden = false;
    clearTimeout(m._zu);
    m._zu = setTimeout(function () {
      m.hidden = true;
    }, 4000);
  }

  /* ort: { name, sections(), zeilen() -> [{key, menge}], zeichnen(antwort), neuLaden() } */
  function mengeVormerken(ort, key, weg) {
    vorgemerkt.push({ ort: ort, key: key, weg: !!weg });
    clearTimeout(mengeTimer);
    mengeTimer = setTimeout(mengeSenden, MENGE_RUHE);
  }

  function mengeSenden() {
    if (laeuft || !vorgemerkt.length) return;
    laeuft = true;
    var liste = vorgemerkt;
    vorgemerkt = [];
    var ort = liste[liste.length - 1].ort;
    standHolen()
      .then(function (c) {
        /* Ein Key aus der Anzeige ist dem Stand unbekannt: einmal frisch
           holen. Bleibt er unbekannt, passt die Anzeige nicht mehr zum
           Server - dann nicht still verwerfen, sondern Fehlerweg. */
        var unbekannt = function () {
          return liste.some(function (v) {
            return !gruppeVon[v.key];
          });
        };
        return (unbekannt() ? standHolen(true) : Promise.resolve(c)).then(function (c2) {
          if (unbekannt()) throw { daten: null };
          return c2;
        });
      })
      .then(function (c) {
        /* Ziel je Gruppe = Summe der angezeigten Mengen ihrer Zeilen */
        var ziel = {};
        var weg = {};
        var orte = [];
        liste.forEach(function (v) {
          var g = gruppeVon[v.key];
          if (orte.indexOf(v.ort) < 0) orte.push(v.ort);
          if (!g) return;
          if (v.weg) weg[g] = true;
          ziel[g] = 0;
        });
        orte.forEach(function (o) {
          o.zeilen().forEach(function (z) {
            var g = gruppeVon[z.key];
            if (g in ziel && !weg[g]) ziel[g] += z.menge;
          });
        });
        /* Keys aus der letzten Antwort: die erste Zeile der Gruppe
           bekommt die Summe, weitere Zeilen 0 - Shopify teilt danach
           selbst wieder auf. */
        var updates = {};
        var erste = {};
        c.items.forEach(function (i) {
          var g = gruppe(i);
          if (!(g in ziel)) return;
          var soll = weg[g] || erste[g] ? 0 : ziel[g];
          erste[g] = true;
          if (soll !== i.quantity) updates[i.key] = soll;
        });
        if (!Object.keys(updates).length) return { ok: true, daten: null };
        /* Haengt die Anfrage, nach 15 s abbrechen - sonst bliebe die
           Schlange fuer immer belegt. */
        var abbruch = window.AbortController ? new AbortController() : null;
        var uhr = abbruch && setTimeout(function () {
          abbruch.abort();
        }, 15000);
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates: updates, sections: ort.sections() }),
          signal: abbruch ? abbruch.signal : undefined
        }).then(function (r) {
          clearTimeout(uhr);
          return r.json().then(function (j) {
            return { ok: r.ok, daten: j };
          });
        });
      })
      .then(function (a) {
        if (!a.ok) throw a;
        if (a.daten) standMerken(a.daten);
        /* Weitergeklickt? Dann nicht zeichnen, die Anzeige gilt noch. */
        if (!vorgemerkt.length) return ort.zeichnen(a.daten);
      })
      .catch(function (f) {
        vorgemerkt = [];
        stand = null;
        var d = f && f.daten;
        melden(d && d.description ? d.description + " Warenkorb neu geladen." : "Menge konnte nicht geändert werden. Warenkorb neu geladen.");
        return standHolen(true)
          .catch(function () {})
          .then(function () {
            return ort.neuLaden();
          })
          .catch(function () {
            melden("Warenkorb konnte nicht geladen werden. Bitte Seite neu laden.");
          });
      })
      .then(function () {
        laeuft = false;
        if (vorgemerkt.length) {
          clearTimeout(mengeTimer);
          mengeTimer = setTimeout(mengeSenden, MENGE_RUHE);
        } else {
          /* Schlange leer: der Stand gilt nur fuer diese Klickfolge.
             Prio-Schalter, Rabattcode oder "In den Warenkorb" aendern
             die Keys auch - die naechste Folge holt /cart.js frisch. */
          stand = null;
        }
      });
  }

  /* Gleiche Gruppe? Ist der Stand noch nicht geladen, reicht die
     Variante vorn im Key ("variante:hash"). */
  function gleicheGruppe(a, b) {
    if (gruppeVon[a] && gruppeVon[b]) return gruppeVon[a] === gruppeVon[b];
    return String(a).split(":")[0] === String(b).split(":")[0];
  }

  /* Ein Klick auf + oder -. zeilen: [{key, menge, setze(n)}].
     Shopify teilt eine Variante bei Rabatten auf mehrere Zeilen
     (z. B. 7 + 4). Minus nimmt deshalb erst aus der geklickten Zeile
     und, wenn die leer ist, aus einer anderen Zeile derselben Gruppe -
     sonst blieben zehn schnelle Klicks bei 7 + 4 an der ersten Zeile
     haengen. minimum gilt fuer die ganze Gruppe. */
  function mengeSchritt(ort, zeilen, key, delta, minimum) {
    var gleiche = zeilen.filter(function (z) {
      return gleicheGruppe(z.key, key);
    });
    var hier = gleiche.filter(function (z) {
      return z.key === key;
    })[0];
    if (!hier) return false;
    if (delta > 0) {
      hier.setze(hier.menge + 1);
    } else {
      var summe = gleiche.reduce(function (s, z) {
        return s + z.menge;
      }, 0);
      if (summe <= minimum) return false;
      var quelle = hier.menge > 0 ? hier : gleiche.filter(function (z) {
        return z.menge > 0;
      }).pop();
      if (!quelle) return false;
      quelle.setze(quelle.menge - 1);
    }
    mengeVormerken(ort, key, false);
    return true;
  }

  window.dzMenge = { vormerken: mengeVormerken, schritt: mengeSchritt, standMerken: standMerken, melden: melden };

  var drawerOrt = {
    name: "drawer",
    sections: function () {
      return sid() + ",cart-icon-bubble";
    },
    zeilen: function () {
      return [].map.call(document.querySelectorAll("[data-dz-cart] [data-dz-line]"), function (z) {
        var w = z.querySelector("[data-dz-menge-wert]");
        var key = z.getAttribute("data-dz-line");
        return { key: key, menge: w ? parseInt(w.textContent, 10) || 0 : mengeVon[key] || 0 };
      });
    },
    zeichnen: function (j) {
      /* Ohne Antwort (nichts zu senden): Anzeige auf den Serverstand */
      if (j && j.sections) neuZeichnen(j.sections);
      else return nachladen(true);
    },
    neuLaden: function () {
      return nachladen(true);
    }
  };

  function drawerZeilen() {
    return [].map.call(document.querySelectorAll("[data-dz-cart] [data-dz-line]"), function (z) {
      var w = z.querySelector("[data-dz-menge-wert]");
      return {
        key: z.getAttribute("data-dz-line"),
        menge: w ? parseInt(w.textContent, 10) || 0 : 0,
        setze: function (n) {
          if (w) w.textContent = n;
        }
      };
    }).filter(function (z) {
      return z.setze && z.key;
    });
  }

  function zeileEntfernen(zeile) {
    var key = zeile.getAttribute("data-dz-line");
    if (!key) return;
    sperren(zeile, true);
    mengeVormerken(drawerOrt, key, true);
  }

  /* Notnagel: Section frisch holen, wenn eine Aenderung schiefging. */
  function nachladen(laut) {
    var id = sid();
    if (!id) return Promise.resolve();
    return fetch(window.location.pathname + "?section_id=" + id)
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var o = {};
        o[id] = html;
        neuZeichnen(o);
      })
      .catch(function (f) {
        /* laut: die Warteschlange will den Fehler sehen und meldet ihn */
        if (laut) throw f;
      });
  }

  /* --- Empfehlungen: erst beim Aufklappen holen ----------------------- */
  function recsEinsetzen(html, still) {
    var panel = document.querySelector("[data-dz-recs-panel]");
    var knopf = document.querySelector("[data-dz-recs-toggle]");
    if (!panel || !knopf) return;
    panel.innerHTML = html;
    panel.classList.add("offen");
    knopf.setAttribute("aria-expanded", "true");
    if (!still) panel.scrollIntoView({ block: "nearest" });
  }

  function recsUmschalten(knopf) {
    var panel = document.querySelector("[data-dz-recs-panel]");
    if (!panel) return;
    if (panel.classList.contains("offen")) {
      panel.classList.remove("offen");
      knopf.setAttribute("aria-expanded", "false");
      return;
    }
    if (recsHtml) {
      recsEinsetzen(recsHtml);
      return;
    }
    knopf.setAttribute("aria-busy", "true");
    fetch(window.location.pathname + "?section_id=" + RECS)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        recsHtml = html;
        recsEinsetzen(html);
      })
      .catch(function () {})
      .finally(function () {
        knopf.removeAttribute("aria-busy");
      });
  }

  /* --- Rabattcode ----------------------------------------------------- */
  var TEXT_KOMBI = "Dieser Code ist nicht mit dem laufenden Angebot kombinierbar.";
  var TEXT_UNGUELTIG = "Dieser Code ist nicht gültig.";

  function fehlerZeigen(text) {
    var f = document.querySelector("[data-dz-code-fehler]");
    if (!f) return;
    f.textContent = text;
    f.classList.add("an");
  }

  function feldFuellen(code) {
    var f = document.querySelector("[data-dz-code]");
    if (f) f.value = code;
  }

  /* Laeuft der automatische 30-%-Rabatt gerade? Erst im Warenkorb
     nachsehen (Zeilen-Allocations), sonst das Liquid-Flag am Koerper. */
  function rabattAktiv(daten) {
    if (daten && daten.items) {
      for (var i = 0; i < daten.items.length; i++) {
        var a = daten.items[i].line_level_discount_allocations;
        if (a && a.length) return true;
      }
    }
    var k = body();
    return !!(k && k.getAttribute("data-dz-rabatt-aktiv") === "true");
  }

  /* Nur anwendbare Codes stehen im Markup - nicht anwendbare bleiben bei
     Shopify zwar am Warenkorb haengen, werden hier aber nicht gezeigt
     und beim naechsten Versuch mit weggeraeumt. */
  function aktiveCodes() {
    return [].map.call(document.querySelectorAll("[data-dz-code-weg]"), function (c) {
      return c.getAttribute("data-dz-code-weg");
    });
  }

  function codeAnwenden() {
    var feld = document.querySelector("[data-dz-code]");
    var fehler = document.querySelector("[data-dz-code-fehler]");
    if (!feld) return;
    var code = (feld.value || "").trim();
    if (fehler) fehler.classList.remove("an");
    if (!code) {
      fehlerZeigen("Bitte einen Code eingeben.");
      return;
    }
    var aktive = aktiveCodes();
    var knopf = document.querySelector("[data-dz-code-anwenden]");
    sperren(knopf, true);

    post("/cart/update.js", { discount: aktive.concat([code]).join(",") })
      .then(function (a) {
        var liste = (a.daten && a.daten.discount_codes) || [];
        var eintrag = null;
        for (var i = 0; i < liste.length; i++) {
          if (String(liste[i].code).toLowerCase() === code.toLowerCase()) eintrag = liste[i];
        }
        if (eintrag && eintrag.applicable === false) {
          /* Shopify laesst den nicht anwendbaren Code am Warenkorb
             kleben. Er wird hier gleich wieder abgeraeumt, sonst
             blockiert er den naechsten Versuch. */
          return post("/cart/update.js", { discount: aktive.join(",") }).then(function (b) {
            var daten = (b.ok && b.daten) ? b.daten : a.daten;
            if (b.ok && b.daten.sections) neuZeichnen(b.daten.sections);
            /* Erst NACH dem Neuzeichnen: der Re-Render ersetzt den
               Koerper und wuerde einen vorher gesetzten Text wegwerfen. */
            fehlerZeigen(rabattAktiv(daten) ? TEXT_KOMBI : TEXT_UNGUELTIG);
            feldFuellen(code);
          });
        }
        if (a.ok && a.daten.sections) neuZeichnen(a.daten.sections);
        else nachladen();
      })
      .catch(function () {
        fehlerZeigen("Code konnte nicht geprüft werden.");
        feldFuellen(code);
      })
      .finally(function () {
        sperren(document.querySelector("[data-dz-code-anwenden]"), false);
      });
  }

  /* Code entfernen: /cart/update.js bekommt die verbleibenden Codes.
     Bleibt keiner uebrig, geht ein leerer String raus - Shopify loescht
     damit alle Codes am Warenkorb. */
  function codeEntfernen(knopf) {
    var weg = knopf.getAttribute("data-dz-code-weg");
    var zeile = knopf.closest("[data-dz-code-ok]");
    if (zeile) sperren(zeile, true);
    var rest = [].map.call(document.querySelectorAll("[data-dz-code-weg]"), function (c) {
      return c.getAttribute("data-dz-code-weg");
    }).filter(function (c) { return c !== weg; });
    post("/cart/update.js", { discount: rest.join(",") })
      .then(function (a) {
        if (a.ok && a.daten.sections) neuZeichnen(a.daten.sections);
        else nachladen();
      })
      .catch(nachladen)
      .finally(function () { if (zeile) sperren(zeile, false); });
  }

  /* --- Prio-Versand: bestehende Mechanik, nur neue Optik -------------- */
  function prioSchalten(box) {
    var wrap = box.closest("[data-dz-prio]");
    if (!wrap) return;
    var vid = wrap.getAttribute("data-prio-variant-id");
    var an = box.checked;
    box.disabled = true;
    var arbeit;
    if (an) {
      arbeit = post("/cart/add.js", { items: [{ id: Number(vid), quantity: 1 }] });
    } else {
      arbeit = fetch("/cart.js")
        .then(function (r) {
          return r.json();
        })
        .then(function (c) {
          var z = c.items.filter(function (i) {
            return String(i.variant_id) === String(vid);
          })[0];
          if (!z) return { ok: true, daten: {} };
          return post("/cart/change.js", { id: z.key, quantity: 0 });
        });
    }
    arbeit
      .then(function (a) {
        if (a.ok && a.daten.sections) neuZeichnen(a.daten.sections);
        else nachladen();
        /* Die Prio-Zeile haengt unten an der Liste. Wird der Schalter
           angehakt, waere sie ohne diesen Sprung unter dem sichtbaren
           Rand entstanden - der Kunde saehe nur den Betrag steigen. */
        if (an) ansEnde();
      })
      .catch(function () {
        box.checked = !an;
        nachladen();
      });
  }

  /* --- ein Klick-Horcher fuer alles, ueberlebt jedes Neuzeichnen ------ */
  document.addEventListener("click", function (e) {
    var t = e.target;

    var recs = t.closest && t.closest("[data-dz-recs-toggle]");
    if (recs) {
      e.preventDefault();
      recsUmschalten(recs);
      return;
    }

    var menge = t.closest && t.closest("[data-dz-menge]");
    if (menge) {
      e.preventDefault();
      var zeile = menge.closest("[data-dz-line]");
      if (!zeile || !zeile.querySelector("[data-dz-menge-wert]")) return;
      /* Minimum 0: Minus bis 0 entfernt die Position, wie bisher */
      mengeSchritt(drawerOrt, drawerZeilen(), zeile.getAttribute("data-dz-line"), menge.getAttribute("data-dz-menge") === "plus" ? 1 : -1, 0);
      return;
    }

    var weg = t.closest && t.closest("[data-dz-entfernen]");
    if (weg) {
      e.preventDefault();
      var z2 = weg.closest("[data-dz-line]");
      if (z2) zeileEntfernen(z2);
      return;
    }

    if (t.closest && t.closest("[data-dz-code-anwenden]")) {
      e.preventDefault();
      codeAnwenden();
      return;
    }

    var codeWeg = t.closest && t.closest("[data-dz-code-weg]");
    if (codeWeg) {
      e.preventDefault();
      codeEntfernen(codeWeg);
      return;
    }

    if (t.closest && t.closest("[data-dz-weiter]")) {
      e.preventDefault();
      var zu = document.querySelector(".dz-cd__zu");
      if (zu) zu.click();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter") return;
    if (e.target && e.target.matches && e.target.matches("[data-dz-code]")) {
      e.preventDefault();
      codeAnwenden();
    }
  });

  document.addEventListener("change", function (e) {
    if (e.target && e.target.id === "dz-prio-check") prioSchalten(e.target);
  });
})();
